/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Archive } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	transactions: {},
};

const setTransactions: ReduxReducer<State, State["transactions"]> = (
	state,
	action,
) => {
	for (const [id, data] of Object.entries(action.payload)) {
		const numericId = Number(id);
		if (!Number.isNaN(numericId)) {
			state.transactions[numericId] = data;
		}
	}

	// state.transactions = action.payload;
};

const archivesTransactionsData = createSlice({
	name: Archive.ConstantOrderSlice.TRANSACTIONS_DATA,
	initialState,
	reducers: {
		setTransactions,
	},
});

export const archivesTransactionsDataAction = archivesTransactionsData.actions;
export const archivesTransactionsDataReducer = archivesTransactionsData.reducer;
export type archivesTransactionsDataState = State;

export default archivesTransactionsData;
